// Gives every fetch in the dashboard the direct-host → Cloudflare-twin fallback
// (see utils/originFallbackCore.js for why). Imported once in main.jsx, after the
// fetch tracker, so the tracker still records the first attempt that failed.
import { installGlobalFetchFallback } from '@/utils/originFallbackCore'
import { trackEvent } from '@/lib/analytics'
import { safeSessionStorage } from '@/lib/safe-storage'

const client =
    typeof window !== 'undefined'
        ? installGlobalFetchFallback({ target: window, storage: safeSessionStorage, track: trackEvent })
        : null

/** Base URL to use now for a host (the twin once the direct host proved unreachable). */
export const preferredOrigin = (base) => (client ? client.preferredOrigin(base) : base)

/** Same, for full URLs handed to iframes and links. */
export const preferredUrl = (url) => (client ? client.preferredUrl(url) : url)

/**
 * A live connection to `base` never reached the server on its current route.
 * Switches the route for this session only if the other route answers; resolves
 * to the base to reconnect to, or null (route unchanged).
 */
export const switchRouteAfterSocketFailure = async (base) => (client ? client.switchRouteAfterSocketFailure(base) : null)

/** socket.io reports transport-level failures (never reached the server) this way. */
export const isTransportFailure = (err) =>
    err?.type === 'TransportError' || /websocket error|xhr poll error|timeout/i.test(String(err?.message || ''))
